import { DEFAULT_MIVO_LOCALE, MIVO_LOCALES, type MivoTranslationKey } from "./ITranslation";

const MIVO_LOCALE_SET = new Set<string>(MIVO_LOCALES);

/** Legacy locale tags accepted on read paths only (cookies, URL, stored rows). */
const LEGACY_PORTUGUESE_LOCALE_TAGS = new Set(["ptBR", "pt-br"]);

export function isRecognizedLegacyLocaleTag(value: string): boolean {
  return LEGACY_PORTUGUESE_LOCALE_TAGS.has(value);
}

export function resolveTranslationLanguage(language?: string | null): MivoTranslationKey {
  if (language != null && MIVO_LOCALE_SET.has(language)) {
    return language as MivoTranslationKey;
  }
  if (isRecognizedLegacyLocaleTag(language ?? "")) {
    return DEFAULT_MIVO_LOCALE;
  }
  return DEFAULT_MIVO_LOCALE;
}

/** Parses `?locale=` and similar inbound tags; returns null when unsupported. */
export function tryParseLocaleParam(value: string): MivoTranslationKey | null {
  if (MIVO_LOCALE_SET.has(value)) {
    return value as MivoTranslationKey;
  }
  if (isRecognizedLegacyLocaleTag(value)) {
    return DEFAULT_MIVO_LOCALE;
  }
  return null;
}
